import { faEdit, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { ListarEtapasPorTipoCasoController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import {
    AtualizarDocumentoTemplateController,
    CadastrarDocumentoTemplateController,
} from "../../../../Controllers/Geral/GestaoDeCadastros/DocumentosTemplate/DocumentosTemplateControllers";
import { ListarTipoDocumentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IDocumentosTemplate } from "../../../../Interfaces/Geral/Documentos/DocumentosInterface";
import { IDocumentoTemplateBody } from "../../../../Interfaces/Geral/GestaoDeCadastro/Documentos/DocumentosInterface";
import { lstAtributos } from "../../../../mocks/variaveisTemplate";
import "./styles.css";
import { Redirect, useParams } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { GetDocumentoTemplateController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface htmlQuill {
    editorHtml: string;
}

interface URLParams {
    idDocumentoTemplate?: string;
}

interface ICadastroTemplateProps {
    template?: IDocumentosTemplate | undefined;
    updateList: () => void;
}

export default function CadastroTemplates(props: ICadastroTemplateProps) {
    const FormMethods = useForm();
    const { reset } = FormMethods;
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: props.template?.DS_TEMPLATE,
    } as htmlQuill);

    const [valorSelecionado, setValorSelecionado] = useState(0);
    const [filtroPesquisa, setFiltroPesquisa] = useState("");

    const [uploading, setUploading] = useState(false);
    // const [isAgendamento, setIsAgendamento] = useState<boolean>(false);

    // const [isEmailConfirmacao, setIsEmailConfirmacao] =
    //     useState<boolean>(false);
    // eslint-disable-next-line
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setValorSelecionado(Number(event.target.value));
    };

    const handleValidateTipoDocumento = (
        event: ChangeEvent<HTMLSelectElement>
    ) => {
        ListarTipoDocumentoController().then((res) => {
            const findTipoDocumento = res.find(
                (tipoDocumento) =>
                    tipoDocumento.ID_TIPO_DOCUMENTO ===
                    Number(event.target.value)
            );
            if (findTipoDocumento) {
                if (findTipoDocumento?.ID_CLASSIFICACAO_DOCUMENTO === 5) {
                    // setIsAgendamento(true);
                    setValorSelecionado(0);
                    // setIsEmailConfirmacao(false);
                } else if (
                    findTipoDocumento?.ID_CLASSIFICACAO_DOCUMENTO === 6 ||
                    findTipoDocumento?.ID_CLASSIFICACAO_DOCUMENTO === 7
                ) {
                    // setIsEmailConfirmacao(true);
                    setValorSelecionado(0);
                    // setIsAgendamento(false);
                } else {
                    // setIsEmailConfirmacao(false);
                    // setIsAgendamento(false);
                }
            }
        });
    };

    const atributosFiltrados =
        valorSelecionado === 0
            ? lstAtributos
            : valorSelecionado > 0
            ? lstAtributos.filter(
                  (varAtr) => varAtr.value === Number(valorSelecionado)
              )
            : lstAtributos.filter((varAtr) => !varAtr.value);

    const atributosFiltradosComPesquisa = atributosFiltrados.filter((varAtr) =>
        varAtr.atributos.find((atr) =>
            atr.campo.toLowerCase().includes(filtroPesquisa.toLowerCase())
        )
    );

    const { idDocumentoTemplate } = useParams<URLParams>();

    const [redirectBack, setRedirectBack] = useState(false);

    const { execute: cadastrarTemplate, loading: cadastrarTemplateLoading } =
        useAsyncCallback(CadastrarDocumentoTemplateController);

    const { execute: atualizarTemplate, loading: atualizarTemplateLoading } =
        useAsyncCallback(AtualizarDocumentoTemplateController);

    const { value: documentoTemplate } = useAsyncEffect(() =>
        GetDocumentoTemplateController(Number(idDocumentoTemplate))
    );

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const handleCadastrarTemplateFormSubmit = (
        formData: IDocumentoTemplateBody
    ) => {
        const convertedTextWithoutLinkTags = convertedText.editorHtml.replace(
            /<a[^>]+value="(.*?)".*?<\/a>/g,
            "$1"
        );
        let modifiedTemplateHTML = convertedTextWithoutLinkTags;
        const imagesToReplace =
            modifiedTemplateHTML.match(/<img[^>]*src="blob[^"]*"[^>]*>/g) || [];

        imagesToReplace.forEach((imageTag) => {
            const uploadedImageUrl = uploadedImages.shift() || "";
            modifiedTemplateHTML = modifiedTemplateHTML.replace(
                /<img[^>]*src="blob[^"]*"[^>]*>/,
                imageTag.replace(/src="blob[^"]*"/, `src="${uploadedImageUrl}"`)
            );
        });
        setConvertedText({ editorHtml: modifiedTemplateHTML });

        if (Number(documentoTemplate) !== 0) {
            atualizarTemplate({
                ...formData,
                DS_TEMPLATE: modifiedTemplateHTML,
                ID_DOCUMENTO_TEMPLATE:
                    documentoTemplate?.ID_DOCUMENTO_TEMPLATE ?? 0,
                DS_ASSUNTO: formData.DS_ASSUNTO,
            }).then(() => {
                props.updateList();
            });
        } else {
            cadastrarTemplate({
                ...formData,
                DS_TEMPLATE: modifiedTemplateHTML,
                DS_ASSUNTO: formData.DS_ASSUNTO,
            }).then(() => {
                props.updateList();
            });
        }
        reset();
        setConvertedText({ editorHtml: "" });
    };

    const SetarValorInicialEditor = useCallback(() => {
        let lstAuxiliar: String[] = [];
        lstAtributos.forEach((lst) => {
            lst.atributos.forEach((atributo) => {
                if (
                    documentoTemplate !== undefined &&
                    lstAuxiliar.indexOf(atributo.parametro) === -1
                ) {
                    if (documentoTemplate && documentoTemplate.DS_TEMPLATE) {
                        documentoTemplate.DS_TEMPLATE =
                            documentoTemplate.DS_TEMPLATE.replaceAll(
                                atributo.parametro,
                                atributo.html
                            );
                    }
                    lstAuxiliar.push(atributo.parametro);
                }
            });
        });
        setConvertedText({ editorHtml: documentoTemplate?.DS_TEMPLATE ?? "" });
    }, [documentoTemplate]);

    useEffect(() => {
        SetarValorInicialEditor();
    }, [SetarValorInicialEditor, documentoTemplate]);

    return (
        <>
            <div className="w-100 p-4">
                <h4>
                    <FontAwesomeIcon
                        icon={!documentoTemplate ? faPaperPlane : faEdit}
                        className="mr-2"
                        size="lg"
                    />
                    {!documentoTemplate
                        ? "Cadastrar Template"
                        : "Editar Template"}
                </h4>
                <hr />

                <FormProvider {...FormMethods}>
                    <UnForm
                        handleSubmit={handleCadastrarTemplateFormSubmit}
                        className="row"
                        usingContext
                    >
                        <div className="col-12 col-md-6">
                            <UnForm.Input
                                name="DS_DOCUMENTO"
                                label="Descrição"
                                wrapperClassName="col-6"
                                defaultValue={documentoTemplate?.DS_DOCUMENTO}
                                registerOptions={{
                                    required: "Insira uma descrição",
                                    validate: {
                                        required: (value: string) =>
                                            value.trim()
                                                ? true
                                                : "Insira uma descrição",
                                    },
                                }}
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <UnForm.Input
                                name="DS_ASSUNTO"
                                label="Assunto"
                                wrapperClassName="col-6"
                                defaultValue={documentoTemplate?.DS_ASSUNTO}
                            />
                        </div>

                        <div className="col-12 col-lg-3">
                            <UnForm.LazySelect
                                name="ID_PRODUTO"
                                label="Produto"
                                wrapperClassName="col-6"
                                defaultValue={documentoTemplate?.ID_PRODUTO}
                                controller={ListarEmpreendimentosController}
                                getDS={(e) => e.DS_EMPREENDIMENTO}
                                getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>

                        <div className="col-12 col-lg-3">
                            <UnForm.LazySelect
                                name="DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                label="Etapa"
                                fatherName="ID_TIPO_CASO"
                                controller={ListarEtapasPorTipoCasoController}
                                getDS={(e) =>
                                    e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                getKeyValue={(e) =>
                                    e.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                wrapperClassName="col-6"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>

                        <div className="col-12 col-lg-2">
                            <UnForm.LazySelect
                                name="ID_TIPO_DOCUMENTO"
                                label="Tipo Documento"
                                defaultValue={
                                    documentoTemplate?.ID_TIPO_DOCUMENTO
                                }
                                wrapperClassName="col-6"
                                controller={ListarTipoDocumentoController}
                                getDS={(d) => d.DS_TIPO_DOCUMENTO}
                                getKeyValue={(d) => d.ID_TIPO_DOCUMENTO}
                                onChange={(e) => handleValidateTipoDocumento(e)}
                                registerOptions={{
                                    required: "Insira um tipo documento",
                                }}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="col-12 col-lg-2">
                            <UnForm.Switch
                                type="checkbox"
                                wrapperClassName="col-6"
                                label="Contrato"
                                name="FL_CONTRATO"
                                labelPosition="top"
                                color="primary"
                                defaultChecked={documentoTemplate?.FL_CONTRATO}
                                onChange={() => {
                                    if (documentoTemplate?.FL_CONTRATO)
                                        documentoTemplate.FL_CONTRATO =
                                            !documentoTemplate.FL_CONTRATO;
                                }}
                                className="pt-3"
                            />
                        </div>
                        <div className="col-12 col-lg-2">
                            <UnForm.Switch
                                type="checkbox"
                                wrapperClassName="col-6"
                                label="Ativo"
                                name="FL_ATIVO"
                                labelPosition="top"
                                color="primary"
                                defaultChecked={documentoTemplate?.FL_ATIVO}
                                onChange={() => {
                                    if (documentoTemplate?.FL_ATIVO)
                                        documentoTemplate.FL_ATIVO =
                                            !documentoTemplate.FL_ATIVO;
                                }}
                                className="pt-3"
                            />
                        </div>

                        <div className="row mb-3 d-flex flex-wrap col-12">
                            <div className="col-md-8 p-4">
                                {uploading && (
                                    <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                        Fazendo upload de imagem{" "}
                                        <Spinner size="sm" color="primary" />
                                    </div>
                                )}

                                <div
                                    style={{
                                        maxHeight: "700px",
                                        overflowY: "auto",
                                    }}
                                >
                                    <FroalaEditor
                                        value={convertedText.editorHtml || ""}
                                        onChange={handleChange}
                                        onImageUploadStart={() =>
                                            setUploading(true)
                                        }
                                        onImageUploadEnd={() =>
                                            setUploading(false)
                                        }
                                        setUploadedImages={setUploadedImages}
                                    />
                                </div>
                                {/* <Editor
                                    onChange={handleChange}
                                    className="cadastroTemplateEditor"
                                    value={convertedText.editorHtml || ""}
                                    bounds={".app"}
                                    placeholder="Mensagem:"
                                    defaultValue={props.template?.DS_TEMPLATE}
                                /> */}
                                <div className="w-100">
                                    {(cadastrarTemplateLoading ||
                                        atualizarTemplateLoading) &&
                                        redirectBack && (
                                            <Redirect
                                                to={
                                                    ACESSOS.GERAL.TELAS
                                                        .GESTAO_TEMPLATES
                                                        .DS_PATH
                                                }
                                            />
                                        )}
                                    <UnForm.SubmitButton
                                        icon={
                                            !documentoTemplate
                                                ? faPaperPlane
                                                : faEdit
                                        }
                                        color="primary"
                                        className="w-50"
                                        wrapperClassName="d-flex justify-content-center pt-5"
                                        disabled={
                                            cadastrarTemplateLoading ||
                                            !convertedText.editorHtml ||
                                            atualizarTemplateLoading
                                        }
                                        onClick={() => setRedirectBack(true)}
                                    >
                                        {!documentoTemplate ? (
                                            <span>Cadastrar Template</span>
                                        ) : (
                                            <span>Editar Template</span>
                                        )}
                                    </UnForm.SubmitButton>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <label htmlFor=""></label>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Pesquisar..."
                                                value={filtroPesquisa}
                                                onChange={(e) =>
                                                    setFiltroPesquisa(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="col-md-5">
                                            <UnForm.Select
                                                label="Tipos Variáveis"
                                                name="TipoTemplate"
                                                className="form-control mb-3"
                                                value={valorSelecionado}
                                                onChange={handleSelectChange}
                                            >
                                                <option value={0}>Todos</option>
                                                <option value={1}>
                                                    Atendimento ao Cliente
                                                </option>
                                                <option value={2}>
                                                    Boleto
                                                </option>
                                                <option value={3}>
                                                    Cobrança
                                                </option>
                                                <option value={4}>
                                                    Vendas
                                                </option>
                                                <option value={5}>
                                                    Agendamentos
                                                </option>
                                                <option value={6}>
                                                    Integração UAU
                                                </option>
                                                <option value={7}>
                                                    Vistoria
                                                </option>
                                            </UnForm.Select>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            maxHeight: "700px",
                                            overflowY: "auto",
                                        }}
                                    >
                                        {atributosFiltradosComPesquisa.map(
                                            (varAtr, varIndex) => (
                                                <div
                                                    key={varIndex}
                                                    className="variableGroup d-flex flex-column"
                                                >
                                                    <div className="d-flex justify-content-between w-100">
                                                        <label className="labelVariaveltitle">
                                                            {varAtr.titleHtml}
                                                        </label>
                                                        {varAtr.repeticao && (
                                                            <label className="repeater">
                                                                (Repetição)
                                                            </label>
                                                        )}
                                                    </div>

                                                    <div className="row mx-1">
                                                        {varAtr.atributos
                                                            .filter((atr) =>
                                                                atr.campo
                                                                    .toLowerCase()
                                                                    .includes(
                                                                        filtroPesquisa.toLowerCase()
                                                                    )
                                                            )
                                                            .map(
                                                                (
                                                                    atr,
                                                                    atrIndex
                                                                ) => (
                                                                    <OverlayTrigger
                                                                        key={
                                                                            atrIndex
                                                                        }
                                                                        overlay={
                                                                            <Tooltip id="tooltip-descricao">
                                                                                {atr.html.match(
                                                                                    /title="([^"]*)"/
                                                                                )?.[1] ||
                                                                                    "Título não encontrado"}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <a
                                                                            href="#/documento/templates/template"
                                                                            className="atributosTemplate bg-white rounded p-2 m-1 shadow-sm"
                                                                            title={
                                                                                atr.campo
                                                                            }
                                                                            style={{
                                                                                cursor: "grab",
                                                                            }}
                                                                            data-value={
                                                                                atr.parametro
                                                                            }
                                                                        >
                                                                            {
                                                                                atr.campo
                                                                            }
                                                                        </a>
                                                                    </OverlayTrigger>
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </>
                            </div>
                        </div>
                    </UnForm>
                </FormProvider>
            </div>
        </>
    );
}
